export default {
  props: {
    error: {required: true},
    context: String,
  },
}